<template>
  <div ref="genericNotification" v-show="show">
    <div class="columns is-mobile is-marginless" v-if="show">
        <div class="column is-narrow is-marginless is-centered is-danger">
          <span class="icon is-size-4 is-white">
            <i class="fas fa-ban"></i>
          </span>
        </div>
        <div class="column is-marginless is-danger-middle">
          <p class="is-size-6">
            <template v-if="showDetailed">
              <strong>Error: </strong>{{message}} <a class="copy-error" @click="copyError()">Copy error</a>
            </template>
            <template v-else>
              <strong>{{message}}</strong>
            </template>
          </p>
          <input class="trace-input" type="hidden" ref="traceInput" :value="JSON.stringify(this.exceptionData)" />
        </div>
        <div class="column is-narrow is-marginless is-danger-middle" v-if="!hide_close_btn">
          <a class="icon is-size-4" href="#" @click.prevent="closeException">
            <i class="far fa-times-circle"></i>
          </a>
        </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        message: '',
        show: false,
        hide_close_btn: undefined, // flag to hide/show close button,
        exceptionData: '',
        showDetailed: true
      }
    },
    created () {
      window.events.$on('exception', (exceptionData, hideCloseBtn) => this.display(exceptionData, hideCloseBtn))
      window.events.$on('closeException', () => this.closeException())
    },
    methods: {
      /**
       * Displays notification message globally
       * @param {Object} exceptionData Exception data
       * @param {boolean} hideCloseBtn flag to hide close btn
       * @returns {null}
       */
      display (exceptionData, hideCloseBtn = false) {
        setTimeout(() => { window.events.$emit('closeFlash') }, 10)
        this.hide_close_btn = hideCloseBtn
        this.message = exceptionData.message
        this.exceptionData = exceptionData
        this.show = true
        this.showDetailed = exceptionData.showDetailed
        try {
          this.$refs.genericNotification.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'start'})
        } catch (e) {
          console.log(e.message)
        }
      },
      /**
       * User clicked on the close button on exception flash
       * @returns {void}
       */
      closeException () {
        this.show = false
      },
      copyError () {
        this.$refs.traceInput.setAttribute('type', 'text')
        this.$refs.traceInput.select()
        document.execCommand('copy')
        this.$refs.traceInput.setAttribute('type', 'hidden')
      }
    }
  }
</script>
<style scoped>
    .is-danger-middle {
        background-color: #fbcdc6;
    }

    .is-danger {
        color:#fff;
        background-color: #fb492c;
    }

    a.icon {
        text-decoration: none;
        color: #58595b;
    }

    .copy-error {
      font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/ExceptionMessage.vue